import axios from 'axios';
import { API_BASE_URL } from '@/constants';

export const fetchPetsServer = async ({
  status,
  filters,
  page = 1,
}: {
  status?: PetStatus;
  filters: Filters;
  page?: number;
}) => {
  const requestFilters = { ...filters };
  if (requestFilters.race === 'mestizo') {
    delete requestFilters['race'];
  }

  const response = await axios.get(`${API_BASE_URL}/pets/`, {
    params: {
      status,
      is_active: true,
      page,
      ...requestFilters,
    },
  });

  return response.data;
};
